<app-navbar></app-navbar>

<div [ngClass]="scrollClass">
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
